import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deletePlan } from 'api/auth.api';

export const useDeletePlan = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePlan,

    onSuccess: (res) => {
      // toast({
      //   title: 'Plan deleted successfully',
      //   description: res?.data?.message || 'Deleted successfully',
      //   status: 'success',
      //   duration: 3000,
      //   isClosable: true,
      //   position: 'top-center',
      // });

      // Refetch plans list
      queryClient.invalidateQueries(['plans-list']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete plan',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
